import { PortalType } from '../config/enum';

/**
 * Extracts the first subdomain from the REACT_APP_API_URL environment variable.
 * @returns {any} The first subdomain if present, otherwise null.
 */
const getFirstSubdomain = (): string => {
  const { hostname } = window.location;

  // localhost or IP address
  if (hostname === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) {
    return '';
  }

  const subdomain = hostname.split('.')[0];

  const blocked = [
    'admin',
    'admin-dev',
    'admin-test',
    'localhost',
    ...Object.values(PortalType).flatMap((v) => [v, `${v}-dev`, `${v}-test`]),
  ];

  return blocked.some((d) => subdomain.includes(d)) ? '' : subdomain;
};
export default getFirstSubdomain;
